import isEmpty from 'lodash-es/isEmpty';
import isNil from 'lodash-es/isNil';
import moment from 'moment-timezone';
import { useMemo } from 'react';
import { useClient } from '../../../ClientProvider';
import useQuery from '../../../useQuery';
export const useDecitraitDetails = ({ plot, orgId }) => {
    const client = useClient();
    const campaignSummaryRequest = useQuery(client.decitrait.summary({ plotId: plot.id }));
    const campaignSummary = campaignSummaryRequest.data;
    const stages = useQuery(client.decitrait.getResources({ organizationId: orgId })).data?.stages;
    // Used on native to calculate to offset of today's row
    const stagesInCampaign = [];
    const formattedCampaignDays = useMemo(() => {
        if (!isNil(campaignSummary) && !isEmpty(campaignSummary)) {
            return campaignSummary?.map((campaignDay, index) => {
                const stageId = !isNil(campaignDay.userSetStage)
                    ? campaignDay.userSetStage
                    : campaignDay.computedStage;
                if (!isNil(stageId) && !stagesInCampaign.includes(stageId)) {
                    stagesInCampaign.push(stageId);
                }
                const previousDay = campaignSummary[index - 1];
                let firstDayOfMildewProtection = false;
                let firstDayOfOidiumProtection = false;
                const nextDay = campaignSummary[index + 1];
                let lastDayOfMildewProtection = false;
                let lastDayOfOidiumProtection = false;
                const currentStageName = stages?.find((stage) => stage.id === stageId)?.name;
                let enteringNewStage = false;
                if (index === 0) {
                    firstDayOfMildewProtection = campaignDay.mildew.protected;
                    firstDayOfOidiumProtection = campaignDay.oidium.protected;
                }
                else if (index > 0 && !isNil(previousDay)) {
                    /** Entering new stage if
                     *  currentDay's userSet is not nil AND userSet is different from previous day userSet or previous day computed
                     *  OR computed is different previous day userSet or previous day computed
                     */
                    if (!isNil(stageId)) {
                        enteringNewStage =
                            stageId !== previousDay.computedStage ||
                                (!isNil(previousDay.userSetStage) && stageId !== previousDay.userSetStage);
                    }
                    firstDayOfMildewProtection = campaignDay.mildew.protected && !previousDay.mildew.protected;
                    firstDayOfOidiumProtection = campaignDay.oidium.protected && !previousDay.oidium.protected;
                }
                if (index === campaignSummary.length - 1) {
                    lastDayOfMildewProtection = campaignDay.mildew.protected;
                    lastDayOfOidiumProtection = campaignDay.oidium.protected;
                }
                else if (index > 0 && !isNil(nextDay)) {
                    lastDayOfMildewProtection = campaignDay.mildew.protected && !nextDay.mildew.protected;
                    lastDayOfOidiumProtection = campaignDay.oidium.protected && !nextDay.oidium.protected;
                }
                return {
                    campaignDay,
                    currentStageName,
                    enteringNewStage,
                    firstDayOfMildewProtection,
                    firstDayOfOidiumProtection,
                    id: `decitrait-table-row-${index}`,
                    isToday: moment(campaignDay.date).isSame(moment().startOf('day')),
                    lastDayOfMildewProtection,
                    lastDayOfOidiumProtection
                };
            });
        }
        return [];
    }, [stages, campaignSummary]);
    return {
        campaignSummary,
        campaignSummaryRequest,
        formattedCampaignDays,
        numberOfStages: stagesInCampaign.length,
        stages
    };
};
